export default __webpack_public_path__ + "static/phoneMobile4-2f4ddfb7ba0dfac4980ce57325657fda.png";